<script>
  import { page } from '$app/stores';
  $: crumbs = $page.url.pathname.split('/');
</script>

<nav class="breadcrumbs">
  <ol>
    {#each crumbs as crumb, index}
      <li>
        {#if index < crumbs.length - 1}
          <a class="link" href={crumbs.slice(0, index + 1).join('/') || '/'}>{crumb || 'Home'}</a>
        {:else}
          {crumb}
        {/if}
      </li>
    {/each}
  </ol>
</nav>
